<table class="table table-hover table-sortable table-file-open">
    <thead>
        <tr>
            <th data-test-id="name-column-header"
                [ngClass]="sortDirectionCssClasses[SORT_COLUMNS.NAME]"
                (click)="setSort(SORT_COLUMNS.NAME)">
                <a href="javascript:void(0)"><span>Name</span></a>
            </th>
            <th class="th-date"
                [ngClass]="sortDirectionCssClasses[SORT_COLUMNS.MODIFY_DATE_OBJ]"
                (click)="setSort(SORT_COLUMNS.MODIFY_DATE_OBJ)">
                <a href="javascript:void(0)"><span>Date modified</span></a>
            </th>

            <th *ngIf="!isOwner">Owner</th>
            <!-- for delete and edit actions -->
            <th class="th-control" *ngIf="isOwner && !selectOnly"></th>
            <th class="th-control" *ngIf="itemTypeInfo ? itemTypeInfo.isEditable && !selectOnly : false"></th>
            <th class="th-control" *ngIf="showOpenItemPreview"></th>
        </tr>
    </thead>
    <tbody *ngFor="let item of formattedItems">
        <tr (click)="selectItem(item)">
            <th *ngIf="!showRadioButtons">
                {{item.name}}
                <span *ngIf="item | isSharedWithOthers"
                      ycnTooltip
                      [tooltipPlacement]="'right'"
                      [tooltipTitle]="item.tooltipMessage"
                      [tooltipHtml]="true">
                    <svg ycnIcon [name]="'icon-team'"></svg>
                </span>
            </th>
            <th *ngIf="showRadioButtons">
                <label class="custom-control custom-radio">
                    <input class="custom-control-input pointer-events-none"
                           type="radio"
                           name="radio-saved-item"
                           value="{{ item.id }}"
                           [checked]="item.id === selectedItemId">
                    <span class="custom-control-indicator"></span>
                    <span class="custom-control-description">
                        {{item.name}}
                        <span *ngIf="item | isSharedWithOthers"
                          ycnTooltip
                          [tooltipPlacement]="'right'"
                          [tooltipTitle]="item.tooltipMessage"
                          [tooltipHtml]="true">
                            <svg ycnIcon [name]="'icon-team'"></svg>
                        </span>
                    </span>
                </label>
            </th>
            <td>{{ item.modify_date | date: "M/d/yyyy h:mm a" }}</td>
            <td *ngIf="!isOwner" [textContent]="item.sharing.owner_name"></td>
            <td *ngIf="isOwner && !selectOnly">
                <a [hidden]="!canDeleteItem(item)"
                   class="btn btn-sm btn-circle btn-transparent btn-edit"
                   data-test-id="delete-saved-item"
                   (click)="openConfirmDeleteModal(item); $event.stopPropagation()">
                    <svg ycnIcon [name]="'icon-delete'"></svg>
                </a>
            </td>
            <td *ngIf="itemTypeInfo ? itemTypeInfo.isEditable && !selectOnly : false">
                <a class="btn btn-xs btn-circle btn-transparent btn-edit"
                   data-test-id="edit-saved-item"
                   (click)="editItem(item); $event.stopPropagation()">
                    <svg ycnIcon [name]="'icon-edit'"></svg>
                </a>
            </td>
            <td *ngIf="showOpenItemPreview">
                <a class="btn btn-xs btn-circle btn-transparent btn-edit"
                   data-test-id="preview-saved-item"
                (click)="openSavedAssetPreviewModal(item); $event.stopPropagation()">
                    <svg ycnIcon class="icon-password-show" [name]="'icon-password-show'"></svg>
                </a>
            </td>
        </tr>
    </tbody>
    <ycn-confirm-modal #confirmDeleteModal
        [confirmButtonText]="'Delete'"
        [confirmHeader]="confirmDeleteHeader"
        [confirmText]="confirmDeleteText"
        (confirmHandler)="confirmDeleteItem($event)">
    </ycn-confirm-modal>
    <ycn-open-item-preview-modal [savedItemType]="savedItemType"></ycn-open-item-preview-modal>
</table>
